/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_No_InfoInputs */



/**
* | output |
* | --- |
* | "No detailed information available for this audit log" |
*
* @param {Audit_Details_No_InfoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_no_info = /** @type {((inputs?: Audit_Details_No_InfoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_No_InfoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine detaillierten Informationen für diesen Audit-Log verfügbar")
	return /** @type {LocalizedString} */ ("No detailed information available for this audit log")
});